module.exports = __webpack_public_path__ + "img/vertical-btn.f7854c08.png";